import _styled from "@emotion/styled-base";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { COLORS, BORDER_RADIUS, GRID, FONT } from '../../constants';
import { ButtonStyles } from '../../internalConstants';
var SIZES = {
  small: '32px',
  medium: '40px',
  large: '48px'
};
var BUTTON_PADDING = {
  small: 6,
  medium: 10,
  large: 10
};

var propsThatVaryBySize = function propsThatVaryBySize(size) {
  var font = FONT.sizes[size];

  if (size === 'small') {
    font.fontSize = '14px';
  }

  return __assign(__assign({}, font), {
    height: SIZES[size],
    paddingTop: BUTTON_PADDING[size],
    paddingBottom: BUTTON_PADDING[size],
    paddingLeft: GRID[size],
    paddingRight: GRID[size]
  });
};

export var styles = {
  primary: {
    normal: {
      text: COLORS.white,
      border: COLORS.blues.primary,
      background: COLORS.blues.primary,
      borderBottom: ButtonStyles.primary.hover
    },
    accent: {
      text: COLORS.white,
      background: ButtonStyles.primary.hover,
      border: ButtonStyles.primary.hover,
      borderBottom: ButtonStyles.primary.hover
    }
  },
  secondary: {
    normal: {
      text: COLORS.grays.dark,
      background: COLORS.white,
      border: COLORS.grays.lighter,
      borderBottom: COLORS.grays.lighter
    },
    accent: {
      text: COLORS.blues.primary,
      background: COLORS.white,
      border: COLORS.blues.primary,
      borderBottom: COLORS.blues.primary
    }
  },
  success: {
    normal: {
      text: COLORS.white,
      background: COLORS.spot.success,
      border: COLORS.spot.success,
      borderBottom: ButtonStyles.success.hover
    },
    accent: {
      text: COLORS.white,
      border: ButtonStyles.success.hover,
      background: ButtonStyles.success.hover,
      borderBottom: ButtonStyles.success.hover
    }
  },
  critical: {
    normal: {
      text: COLORS.white,
      background: COLORS.spot.critical,
      border: COLORS.spot.critical,
      borderBottom: ButtonStyles.critical.hover
    },
    accent: {
      text: COLORS.white,
      border: ButtonStyles.critical.hover,
      background: ButtonStyles.critical.hover,
      borderBottom: ButtonStyles.critical.hover
    }
  }
};

var buildButton = function buildButton(appearance) {
  var style = styles[appearance];
  return {
    backgroundColor: style.normal.background,
    color: style.normal.text,
    fill: style.normal.text,
    border: "1px solid " + style.normal.border,
    borderBottom: "2px solid " + style.normal.borderBottom,
    lineHeight: 'normal',
    '&:hover, &:active, &:focus': {
      backgroundColor: style.accent.background,
      borderColor: style.accent.border,
      color: style.accent.text,
      fill: style.accent.text
    },
    '&:visited': {
      color: style.accent.text
    },
    '&[disabled]': {
      borderColor: style.normal.border,
      backgroundColor: style.normal.background,
      color: style.normal.text,
      fill: style.normal.text,
      border: "1px solid " + style.normal.border,
      borderBottom: "2px solid " + style.normal.borderBottom,
      opacity: 0.3,
      cursor: 'not-allowed'
    },
    '&[disabled]:hover': {
      borderColor: style.normal.border,
      backgroundColor: style.normal.background,
      color: style.normal.text,
      fill: style.normal.text,
      border: "1px solid " + style.normal.border,
      borderBottom: "2px solid " + style.normal.borderBottom,
      opacity: 0.3,
      cursor: 'not-allowed'
    }
  };
};

var primaryButton = buildButton('primary');
var secondaryButton = buildButton('secondary');
var successButton = buildButton('success');
var criticalButton = buildButton('critical');

var getComponentStylesByAppearance = function getComponentStylesByAppearance(appearance) {
  switch (appearance) {
    case 'secondary':
      return secondaryButton;

    case 'success':
      return successButton;

    case 'critical':
      return criticalButton;

    case 'primary':
    default:
      return primaryButton;
  }
};

export var StyledButton = _styled("button", {
  target: "e1f0y4hh0",
  label: "StyledButton"
})({
  borderRadius: BORDER_RADIUS.small,
  cursor: 'pointer',
  fontFamily: FONT.family,
  margin: 0,
  position: 'relative',
  fontWeight: 'normal',
  textDecoration: 'none',
  textAlign: 'center',
  boxSizing: 'border-box',
  overflow: 'visible',
  textTransform: 'none',
  transition: "\n    background-color " + ButtonStyles.transitionBehaviour + ",\n    color " + ButtonStyles.transitionBehaviour + ",\n    border-color " + ButtonStyles.transitionBehaviour + ",\n    fill " + ButtonStyles.transitionBehaviour,
  outline: 'none',
  userSelect: 'none',
  whiteSpace: 'nowrap',
  alignItems: 'center',
  justifyContent: 'center'
}, function (props) {
  return __assign(__assign(__assign({}, propsThatVaryBySize(props.size)), getComponentStylesByAppearance(props.appearance)), {
    width: props.stretch ? '100%' : 'auto',
    display: props.stretch ? 'flex' : 'inline-flex'
  });
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Button/styles.js
// module id = 800
// module chunks = 0